<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<div class="audit-log-container page-container card col-md-8">
						<ThePageHeader @export-csv-event="exportCsv" @export-excel-event="exportExcel" :renderExportLog="!isLoading && pagination != null"></ThePageHeader>
						
						<div class="row" v-if="pageError == ''">
							<div class="row p-3 pb-0">
								<div class="col-md-4">
									<Dropdown :options="employees" optionLabel="name" optionValue="identifier" placeholder="Employee" v-model="filterEmployeeModel.value" :filter="true" :showClear="true" />
								</div>
								
								<div class="col-md-4">
									<Calendar dateFormat="yy-mm-dd" selectionMode="range" :manualInput="true" placeholder="Date Range" v-model="filterDateModel" />
								</div>
								
								<div class="col-md-4">
									<MultiSelect :options="actionPerformeds" optionLabel="name" optionGroupLabel="name" optionGroupChildren="actions" optionValue="value" filter placeholder="Action Performed" v-model="filterActionPerformedModel.value" />
								</div>
							</div>
							
							<div class="row p-3">
								<div class="col-md-4">
										<Dropdown :options="companies" optionLabel="code" optionValue="code" filter :filterFields="['code', 'name']" showClear :placeholder="isCompanyLoading ? ('Loading...') : 'Company'" :loading="isCompanyLoading" v-model="filterCompanyModel.value">
											<template #value="slotProps">
												<div v-if="slotProps.value" class="d-flex align-items-center">
													<span class="col-md-3">{{ filterCompanyCodeByValue(slotProps.value) }}</span>
													<span class="col-md-9">{{ filterCompanyNameByValue(slotProps.value) }}</span>
												</div>
												<span v-else>
													{{ slotProps.placeholder }}
												</span>
											</template>

											<template #option="slotProps">
												<div class="d-flex align-items-center col-md-12">
													<span class="col-md-3">{{ slotProps.option.code }}</span>
													<span class="col-md-9">{{ slotProps.option.name }}</span>
												</div>
											</template>
										</Dropdown>
									</div>
									
								<div class="col-md-4">
									<InputText class="p-inputtext" type="text" maxlength="10" placeholder="Company Code" v-model="filterActionCommentModel.value" />	
								</div>
							</div>
							
							<div class="row p-3">
								<div class="col-md-5 d-flex align-items-center">
									<Button class="p-button-sm" @click="find(1)" label="Search"/>
									<span class="p-1"></span>
									<Button class="p-button-sm p-button-secondary" @click="reset" label="Reset"/>
								</div>
									
								<div class="col-md-7">
									<Paginator :first="paginator" :pageLinkSize="3" :rows="pagination.itemsPerPage" :totalRecords="pagination.totalItems" @page="find($event.page + 1)" v-if="pagination.currentPage != 0" />
								</div>
							</div>
							
							<div class="row">
								<div class="col-md-12 p-4">
									<table class="p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12">
										<thead class="p-datatable-thead">
											<tr>
												<th style="width: 8%;">#</th>
												<th style="width: 25%; cursor: pointer;" @click="sort('x.employee.name')">Name <span class="pi" :class="[sortingModel.columnName == 'x.employee.name' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 20%; cursor: pointer;" @click="sort('x.actionDate')">Action Date <span class="pi" :class="[sortingModel.columnName == 'x.actionDate' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 42%; cursor: pointer;" @click="sort('x.actionPerformed')">Action Performed <span class="pi" :class="[sortingModel.columnName == 'x.actionPerformed' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 5%;"></th>
											</tr>
										</thead>
										<tbody class="p-datatable-tbody" v-if="!isLoading">
											<tr v-for="(auditLog, index) in pagination.auditLogs" :key="index" v-on:click="viewActionComment(auditLog)">
												<td>{{((pagination.currentPage - 1) * pagination.itemsPerPage) + index + 1}}</td>
												<td>{{auditLog.name}}</td>
												<td>{{formatToDateTime(auditLog.actionDate)}}</td>
												<td>{{auditLog.actionPerformed}}</td>
												<td><FontAwesomeIcon :icon="['fas', 'message']" size="sm" v-if="auditLog.actionComment != null" /></td>
											</tr>
										</tbody>
									</table>
								</div>
								
								<div class="error-no-record" v-if="!isLoading && pagination.auditLogs.length == 0">
									<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
									<h6><span>No Record Found</span></h6>
								</div>
								
								<TheTableLoading v-if="isLoading"></TheTableLoading>
							</div>
						</div>
						
						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
	
	<Dialog header="Action Comment" v-model:visible="displayModal" :style="{width: '50vw'}" :draggable="false" :modal="true" :closable="true" @hide="closeActionComment" >
		<div class="row">
			<Card class="card-audit-log">
				<template #title>
					{{auditLog.actionPerformed}}
				</template>
    
				<template #content>
					<TheLoading v-if="isActionCommentLoading"></TheLoading>
					<pre>{{auditLog.actionComment}}</pre>
				</template>
			</Card>
		</div>
	</Dialog>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import store from "@/store";
	import auditLogApi from "@/api/auditlog-api";
	import employeeApi from "@/api/employee-api";
	import companyApi from "@/api/company-api"; 
	import actionPerformedMixin from "@/mixin/action-performed";
	import dateUtilsMixin from "@/mixin/utils/date-utils";
	import csvUtilsMixin from "@/mixin/utils/csv-utils";
	import excelUtilsMixin from "@/mixin/utils/excel-utils";
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import TheTableLoading from "@/components/TheTableLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	import TheLoading from "@/components/TheLoading.vue";
	
	export default defineComponent({
		mixins: [actionPerformedMixin, dateUtilsMixin, csvUtilsMixin, excelUtilsMixin],
		components: {
			TheHeader,
			TheFooter,
			ThePageHeader,
			TheTableLoading,
			ThePageError,
			TheLoading
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				employees: [] as any[],
				companies: [] as any[],
				pagination: {currentPage: 0, itemsPerPage: 10, auditLogs: [], totalItems: 0},
				sortingModel: {columnName: "x.actionDate", isAscending: false},
				filterEmployeeModel: {value: null},
				filterDateModel: null as any[] | null,
				filterActionPerformedModel: {value: ""},
				filterCompanyModel: {value: null},
				filterActionCommentModel: {value: ""},
				isLoading: false,
				isEmployeeLoading: false,
				auditLog: {identifier: null, actionPerformed: null, actionComment: null},
				displayModal: false,
				isExporting: false,
				isCompanyLoading: false,
				isActionCommentLoading: false,
			}
		},
		watch: {
			filterLegalGroupId(newValue: any) {				
				this.loadCompanyList();
			}
		},
		mounted: function() {
			if (this.pageError == '') {
				this.find(1);
				
				this.isEmployeeLoading = true;
				employeeApi.employeeList({})
					.then(response => {
						this.employees = response.data.listSet;
						this.isEmployeeLoading = false;
					})
					.catch(error => {
						this.isEmployeeLoading = false;
					});
					
				this.loadCompanyList();
			}
		},
		computed: {
			paginator() {
				return ((this.pagination.currentPage - 1) * this.pagination.itemsPerPage);
			},
			filterLegalGroupId() {
				return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel.identifier : null);
			},
		},
		methods: {
			loadCompanyList() {
				this.filterCompanyModel = {value: null}
				
				this.isCompanyLoading = true;
				companyApi.companyList({}, this.filterLegalGroupId)
					.then(response => {
						this.companies = response.data.listSet;
						this.isCompanyLoading = false;
					})
					.catch(error => {
						this.isCompanyLoading = false;
					});
			},
			sort(columnName: string) {
				if (this.sortingModel.columnName == columnName) {
					this.sortingModel.isAscending = !this.sortingModel.isAscending;
				}
				
				else {
					this.sortingModel.columnName = columnName;
					this.sortingModel.isAscending = true;
				}
				this.find(1);
			},
			find(page: number) {
				this.isLoading = true;
				auditLogApi.auditLogFind({
						paginationModel: {currentPage: page},
						sortingModel: this.sortingModel,
						filterEmployeeModel: this.filterEmployeeModel,
						filterStartDateModel: {value: (this.filterDateModel != null && this.filterDateModel[0] != null ? this.formatToDateTime(this.formatToDate(this.filterDateModel[0]) + " 00:00:00") : null)},
						filterEndDateModel: {value: (this.filterDateModel != null && this.filterDateModel[1] != null ? this.formatToDateTime(this.formatToDate(this.filterDateModel[1]) + " 23:59:59") : null)},
						filterActionPerformedModel: this.filterActionPerformedModel,
						filterCompanyModel: this.filterCompanyModel,
						filterActionCommentModel:this.filterActionCommentModel
						
					})
					.then(response => {
						this.pagination = {currentPage: response.data.currentPage, itemsPerPage: response.data.itemsPerPage, auditLogs: response.data.rowSet, totalItems: response.data.totalItems}
						this.isLoading = false;
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 3000});
					})
			},
			reset() {
				this.pagination = {currentPage: 0, itemsPerPage: 10, auditLogs: [], totalItems: 0};
				this.sortingModel = {columnName: "x.actionDate", isAscending: false};
				this.filterEmployeeModel = {value: null};
				this.filterDateModel = null as any[] | null;
				this.filterActionPerformedModel = {value: ""};
				this.filterCompanyModel = {value: null};
				this.filterActionCommentModel =  {value: ""};
				
				this.find(1);
			},
			viewActionComment(auditLog: any) {
				if (auditLog.actionComment != null) {
					this.auditLog.actionPerformed = auditLog.actionPerformed;
					if (auditLog.actionComment === "log_file") {
						this.isActionCommentLoading = true
						auditLogApi.auditLogGetActionComment({auditLogId: auditLog.identifier})
							.then(response => {
								this.isActionCommentLoading = false;
								this.auditLog.actionComment = JSON.parse(response.data);
							})
							.catch(error => {
								this.isActionCommentLoading = false;
								this.$toast.add({severity: "error", summary: "Error", detail: "Error retrieving action comment", life: 3000});
							}
						);
					}
					else {
						this.auditLog.actionComment = JSON.parse(auditLog.actionComment);
					}
					this.displayModal = true;
				}
			},
			closeActionComment() {
				this.auditLog = {identifier: null, actionPerformed: null, actionComment: null};
			},
			exportCsv() {
				this.isExporting = true;
				auditLogApi.auditLogExport({
					sortingModel: this.sortingModel,
					filterEmployeeModel: this.filterEmployeeModel,
					filterStartDateModel: {value: (this.filterDateModel != null && this.filterDateModel[0] != null ? this.formatToDate(this.filterDateModel[0]) + " 00:00:00" : null)},
					filterEndDateModel: {value: (this.filterDateModel != null && this.filterDateModel[1] != null ? this.formatToDate(this.filterDateModel[1]) + " 23:59:59" : null)},
					filterActionPerformedModel: this.filterActionPerformedModel,
					filterCompanyModel: this.filterCompanyModel,
					filterActionCommentModel:this.filterActionCommentModel
				})
				.then(response => {
					this.isExporting = false;
					this.downloadCsv(response.data.rowSet);
				})
				.catch(error => {
					this.isExporting = false;
					this.$toast.add({severity: "error", summary: "Error", detail: error, life: 3000});
				})
			},
			exportExcel() {
				this.isExporting = true;
				auditLogApi.auditLogExport({
					sortingModel: this.sortingModel,
					filterEmployeeModel: this.filterEmployeeModel,
					filterStartDateModel: {value: (this.filterDateModel != null && this.filterDateModel[0] != null ? this.formatToDate(this.filterDateModel[0]) + " 00:00:00" : null)},
					filterEndDateModel: {value: (this.filterDateModel != null && this.filterDateModel[1] != null ? this.formatToDate(this.filterDateModel[1]) + " 23:59:59" : null)},
					filterActionPerformedModel: this.filterActionPerformedModel,
					filterCompanyModel: this.filterCompanyModel,
					filterActionCommentModel:this.filterActionCommentModel
				})
				.then(response => {
					this.isExporting = false;
					this.downloadExcel(response.data.rowSet);
				})
				.catch(error => {
					this.isExporting = false;
					this.$toast.add({severity: "error", summary: "Error", detail: error, life: 3000});
				})
			},
			downloadCsv(auditLogs: any) {
				let columnDelimiter = ',';
				let lineDelimiter = '\n';
				
				let result = '';
				if (auditLogs != null) {
					result += 'Number' + columnDelimiter + 'Name' + columnDelimiter + 'Action Date' + columnDelimiter + 'Action Performed' + columnDelimiter + 'Action Comment';	
					result += lineDelimiter;
					
					for (let i = 0; i < auditLogs.length; i++) {
						result += (i + 1) + columnDelimiter + auditLogs[i].name + columnDelimiter + this.formatToDateTime(auditLogs[i].actionDate) + columnDelimiter + auditLogs[i].actionPerformed + columnDelimiter + (auditLogs[i].actionComment == null ? '' : ('"' + auditLogs[i].actionComment.replaceAll('"', '\'') + '"'));
						result += lineDelimiter;
					}
				}

				this.downloadCsvFile(result, "audit_log_" + this.formatToSimpleDateTime(new Date()) + '.csv');
			},
			downloadExcel(auditLogs: any) {
				let result = [];
				if (auditLogs != null) {
					for (let i = 0; i < auditLogs.length; i++) {
						var row = {} as any;
						row['Number'] = (i + 1).toString();
						row['Name'] = auditLogs[i].name;
						row['Action Date'] = this.formatToDateTime(auditLogs[i].actionDate);
						row['Action Performed'] = auditLogs[i].actionPerformed;
						row['Action Comment'] = (auditLogs[i].actionComment == null ? null : auditLogs[i].actionComment.replaceAll('"', '\''));
						
						result.push(row);
					}
				}
				
				this.downloadExcelFileWithJson(result, "audit_log_" + this.formatToSimpleDateTime(new Date()) + '.xlsx');
			},
			filterCompanyCodeByValue: function (value: any) {
				var companies = this.companies.filter(function (company: any) {
					if (company.code == value) {
						return company;
					}
				});
				if (companies != null && companies.length > 0) {
					return companies[0].code;
				}
				return null;
			},
			filterCompanyNameByValue: function (value: any) {
				var companies = this.companies.filter(function (company: any) {
					if (company.code == value) {
						return company;
					}
				});
				if (companies != null && companies.length > 0) {
					return companies[0].name;
				}
				return null;
			},
		}
	});
</script>
